const nestedTextImageBlock = {
  displayField: 'internalName',
  name: 'Nested Text Image Block',
  description: 'For use within a Stacked, Wide Stacked, or Variant Stacked Text and Image block',
  fields: [
    {
      id: 'internalName',
      name: 'Internal Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Headline',
      type: 'Text',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic' ],
          message: 'Only bold and italic marks are allowed'
        },
        { enabledNodeTypes: [], message: 'Nodes are not allowed' },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaText',
      name: 'CTA Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl',
      name: 'CTA Url',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'nestedTextImageBlock',
    version: 10,
    updatedAt: '2023-08-02T21:00:39.340Z'
  }
};
export default nestedTextImageBlock;